import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { NavDropdown, Tab, Tabs } from "react-bootstrap";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import {
  // notificationResponse,
  notificationData,
  // notificationClear,
  notificationSingleData,
  // notificationSingleResponse,
  notificationSingleClear,
  notificationAllReadData,
  // notificationAllReadResponse,
  // notificationAllReadClear,
  notificationCountData,
  notificationAllData,
  // notificationCountResponse,
  // notificationCountClear,
} from "../redux/notification/actions";
import { clickStreamUser, SessionKeys, timezoneArea } from "../utils/AppUtils";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";

// import CONFIG from "../utils/config";
import moment from "moment";
import ShimmerNotification from "./Layouts/ShimmerNotification";
import { LegendToggleTwoTone } from "@mui/icons-material";



const Notification = () => {


  const navigate = useNavigate();
  const dispatch = useDispatch();

  const notificationResData = useSelector(
    (state) => state?.notification?.notificationData
  );

  const notificationSingleResData = useSelector(
    (state) => state?.notification?.notificationSingleData
  );
  const notificationReadAllResData = useSelector(
    (state) => state?.notification?.notificationAllData
  );
  const notificationAllReadResData = useSelector(
    (state) => state?.notification?.notificationAllReadData
  );
  const notificationCountResult = useSelector(
    (state) => state?.notification?.notificationCountData
  );
  const blinkNotification = useSelector(state => state.home.blinkNotification)

  // console.log("Count notificationss", notificationCountResult);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const auth = useSelector((state) => state.auth);
  const userDetailRes = useSelector((state) => state.user.userBroker);

  const [notification, setNotification] = useState([]);
  const [showUnRead, setShowUnRead] = useState(false);
  // const [showResults, setShowResults] = useState(true);
  const [notificationCount, setNotificationCount] = useState(0);
  const [id, setId] = useState(null);
  const [imgLoader, setImgLoader] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [showNotificationPulse, setShowNotificationPulse] = useState(
    localStorage.getItem(SessionKeys.NOTI_SHOW) === "true" ? true : false
  )
  const [timezone, setTimezone] = useState('')
  const [clickedShowUnread, setClickedShowUnread] = useState(true);
  const [isAllRead, setIsAllRead] = useState(false)
  const [activeTab, setActiveTab] = useState('unread')
  const [shimmerLoading, setShimmerLoading] = useState(false);


  useEffect(() => {
    // console.log("userDetailRes: ", userDetailRes);
    if (!_.isEmpty(userDetailRes?.payload?.payload)) {
      const timeZone = userDetailRes.payload.payload.timezone ?
        userDetailRes.payload.payload.timezone.replace(':', '') : '-0500'
      setTimezone(timeZone)
    }
  }, [userDetailRes]);

  let allNotifications;
  const [loadMore, setloadMore] = useState(false);
  const [totalNotificationCount, setTotalNotificationCount] = useState();
  const [VisibleNotificationsCount, setVisibleNotificationsCount] = useState();
  useEffect(() => {
    if (!_.isEmpty(notificationResData)) {
      setImgLoader(false);
      setShimmerLoading(false);
      if (notificationResData?.status === "success") {
        let isReadAll = true;
        let datas = notificationResData?.payload?.payload?.dataList;
        setTotalNotificationCount(notificationResData?.payload?.payload?.total_notification);
        allNotifications = [...notification, ...datas];
        const uniqueArray = _.uniqBy(allNotifications, 'id');
        setVisibleNotificationsCount(uniqueArray.length);
        for (const item of datas) {
          if (item.status === "unread") {
            isReadAll = false;
          }
        }
        setIsAllRead(isReadAll);
        setNotification(uniqueArray);
      }
      setIsLoading(false)
      // dispatch(notificationClear());
    }
  }, [notificationResData]);

  useEffect(() => {
    if (!_.isEmpty(notificationCountResult)) {
      setImgLoader(false);
      console.log('check--', notificationCountResult)
      if (notificationCountResult?.status === "success") {
        const count = notificationCountResult?.payload?.payload?.unread_count;
        if (count > notificationCount) {
          localStorage.setItem(SessionKeys.NOTI_SHOW, true)
          setShowNotificationPulse(true)
        }
        setNotificationCount(count);
      }
    }
  }, [notificationCountResult]);

  useEffect(() => {
    if (!_.isEmpty(notificationSingleResData)) {
      if (notificationSingleResData?.status === "success") {
        // console.log(notificationSingleResData);
        const notificationDataSingle =
          notificationSingleResData.payload.payload.dataList;
        if (!_.isEmpty(notificationDataSingle)) {
          setNotification(notificationDataSingle);
          for (let n of notificationDataSingle) {
            if (n.id === id) {
              goToNotification(n.redirection_key, n.id, n.redirection_value, n);
            }
          }
          onClickOfAllTab();
        }
        dispatch(notificationSingleClear());
      }
    }
  }, [notificationSingleResData]);

  useEffect(() => {
    getNotificationCount();
  }, [dispatch]);

  useEffect(() => {
    if (isOpen) {
      setShowUnRead(false)
      setActiveTab('unread') //all to unread
      // getNotificationList(); // changed to unread API
      getNotificationAllUnread();
      if (showNotificationPulse) {
        localStorage.setItem(SessionKeys.NOTI_SHOW, false)
        setShowNotificationPulse(false)
      }
    }
  }, [isOpen])
  //let counter=1;





  const [counter, setCounter] = useState(0);
  const [alltabClick, setalltabClick] = useState(false);
  const getNotificationList = (isClick = false) => {
    console.log("alltab", alltabClick);
    var limit = 0;
    isClick ? limit = 0 : limit = Math.floor(notification.length / 10);
    console.log("lenght in api", notification.length);
    console.log("limit--", limit);
    setShimmerLoading(true);
    dispatch(
      notificationData({
        module: "myNotification",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          offset: limit + 1
        },
      })
    );
    setalltabClick(false);

  };
  useEffect(() => {

  }, [counter]);
  // const handleLoadMore =()=>{
  //     setCounter((counter)=>counter+1);
  // }
  const onClickOfAllTab = () => {
    setCounter(0);
    setNotification([]);
    setalltabClick(true);
    getNotificationList(true);
  }


  const markAsRead = (id) => {
    setId(id);
    dispatch(
      notificationSingleData({
        module: "myNotification",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          status: "read",
          id: [id],
        },
      })
    );
  };

  const markAllAsRead = () => {
    let idArr = []
    for (let i = 0; i < notification.length; i++) {
      const element = notification[i];
      if (element.status !== 'read') {
        idArr.push(element.id)
      }

    }
    dispatch(
      notificationAllData({
        module: "myNotification",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          status: "read",
          id: [],
        },
      })
    );
  };
  useEffect(() => {
    if (!_.isEmpty(notificationReadAllResData)) {
      if (notificationReadAllResData?.status === "success") {
        // console.log(notificationSingleResData);
        setIsLoading(true)
        console.log('activTab: ', activeTab)
        setActiveTab("unread") //all to unread
        onClickOfUnreadTab();

      }
    }
  }, [notificationReadAllResData]);

  const getNotificationAllRead = () => {
    dispatch(
      notificationAllReadData({
        module: "myNotification",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          status: "read",
        },
      })
    );
  };

  // let unreadCounter=1;
  const [unreadCounter, setunreadCounter] = useState(0);
  const getNotificationAllUnread = (click = false) => {
    setShimmerLoading(true);
    var limit = 0;
    click ? limit = 0 : limit = Math.floor(notification.length / 10);
    dispatch(
      notificationData({
        module: "myNotification",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          status: "unread",
          offset: limit + 1,
        },
      })
    );

  };
  useEffect(() => {

  }, [unreadCounter]);



  // const unreadLoadMoreHandler =()=>{
  //   setunreadCounter((unreadCounter)=>unreadCounter+1);
  // }

  const onClickOfUnreadTab = () => {
    setNotification([]);
    setClickedShowUnread(true);
    setunreadCounter(1);
    getNotificationAllUnread(true);
  }



  const getNotificationCount = () => {
    setTimeout(() => {
      dispatch(
        notificationCountData({
          module: "myNotificationCount",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          },
        })
      );
    }, 4000)
  };

  const goToNotification = (keyword, id, redirection_value, item) => {
    switch (keyword) {
      case "certificate":
        // console.log("my certificates clicked");
        // console.log("Id clicked", id);
        navigate("/profile/edit?section=edit&tab=6&user_id=" + localStorage.getItem(SessionKeys.USER_ID));
        clickStreamUser("my-certificates_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "badge":
        // console.log("Id clicked", id);
        navigate("/profile/edit?section=edit&tab=7&user_id=" + localStorage.getItem(SessionKeys.USER_ID));

        clickStreamUser("notification-clicked-redirect-badge", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "administrator-dashboard":
        if (!_.isEmpty(redirection_value)) {
          navigate(redirection_value); //navigate("/role-play");
        }
        break;
      case "request-role":
        navigate("/accept-role");
        // console.log("Id clicked", id);
        clickStreamUser("role_requests_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "home":
        navigate("/home");
        // console.log("Id clicked", id);
        clickStreamUser("role_requests_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "role-play":
        if (!_.isEmpty(redirection_value)) {
          navigate(redirection_value); //navigate("/role-play");
        }
        // console.log("Id clicked", id);
        clickStreamUser("role_requests_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "review":
        navigate(`/learn/roleplay-review/detail/${item?.roleplay_ecom_id}?type=review&submit_id=${item?.roleplay_entity_id}`);
        // console.log("Id clicked", id);
        clickStreamUser("role_requests_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "feedback":
        navigate(`/learn/roleplay/detail/${item?.roleplay_ecom_id}?submit_id=${item?.roleplay_entity_id}`);
        clickStreamUser("role_requests_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "profile":
        navigate("/profile/edit?section=edit&tab=1&user_id=" + localStorage.getItem(SessionKeys.USER_ID));
        // console.log("Id clicked", id);
        clickStreamUser("role_requests_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "course-listing":
        if (!_.isEmpty(redirection_value)) {
          navigate(redirection_value);
        }
        // console.log("Id clicked", id);
        clickStreamUser("my_course_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "video-listing":
        if (!_.isEmpty(redirection_value)) {
          navigate(redirection_value);
        }
        // console.log("Id clicked", id);
        clickStreamUser("my_video_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "learning path":
        if (!_.isEmpty(redirection_value)) {
          navigate(redirection_value); //navigate("/learn/learningpath");
        }
        // console.log("Id clicked", id);
        clickStreamUser("learning_paths_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "onboarding-path":
        if (!_.isEmpty(redirection_value)) {
          navigate(redirection_value); //navigate("/learn/learningpath");
        }
        // console.log("Id clicked", id);
        clickStreamUser("my_onboarding_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "course":
        navigate("/my-courses");
        // console.log("Id clicked", id);
        clickStreamUser("learning_paths_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "certificate-listing":
        if (!_.isEmpty(redirection_value)) {
          navigate(redirection_value);
        }
        break;
      case "session-listing":
        if (!_.isEmpty(redirection_value)) {
          navigate(redirection_value);
        }
        break;
      case "codeOfEthics":
        navigate("/codeOfEthics");
      default:
        break;
    }
  };
  //setKeyword(payload.data);
  var NinetyNine = "99+";

  const containerRef = useRef(null);

  const [loader, setloader] = useState(false);
  const handleScroll = () => {

    setloader(true);
    const container = containerRef.current;

    if (container) {
      const { scrollTop, scrollHeight, clientHeight } = container;

      if (scrollHeight - clientHeight - 1 <= scrollTop) {

        if (VisibleNotificationsCount < totalNotificationCount) {
          getNotificationList();
        }
        else {
          setloader(false);
        }
      }

    }
  };

  const unreadcontainerRef = useRef(null);
  const handleScrollUnread = () => {
    setloader(true);
    const container = unreadcontainerRef.current;
    if (container) {
      const { scrollTop, scrollHeight, clientHeight } = container;
      if (scrollHeight - clientHeight - 1 <= scrollTop) {
        setClickedShowUnread(false);
        if (VisibleNotificationsCount < totalNotificationCount) {
          getNotificationAllUnread();
        }
        else {
          setloader(false);
        }
      }

    }
  };




  return (
    <>
      <li
        className="nav-item dropdown notifydroprsp"
        id="myCheck"
      >
        {showNotificationPulse === true
          ?
          <span
            className={
              notificationCount === 0
                ? ""
                : "noticount"
            }
          >
            {/* {notificationCount > 99
            ? `${NinetyNine}`
            : notificationCount > 0
            ? notificationCount
            : ""} */}
          </span> : ''}

        <NavDropdown
          onToggle={() => {
            setIsOpen(!isOpen)
            setalltabClick(true);
            setNotification([]);
          }}

          className="notification-nav"
          title={
            <span className="iconno" title="Notification">

              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" onClick={() => {
                clickStreamUser("notifications-button-clicked", {
                  userId: authBroker?.payload?.user.user_id,
                });
              }} viewBox="0 0 16 21" fill="none">
                <path d="M1 17.0898C0.716667 17.0898 0.479167 16.994 0.2875 16.8023C0.0958333 16.6107 0 16.3732 0 16.0898C0 15.8065 0.0958333 15.569 0.2875 15.3773C0.479167 15.1857 0.716667 15.0898 1 15.0898H2V8.08984C2 6.70651 2.41667 5.47734 3.25 4.40234C4.08333 3.32734 5.16667 2.62318 6.5 2.28984V1.58984C6.5 1.17318 6.64583 0.81901 6.9375 0.527344C7.22917 0.235677 7.58333 0.0898438 8 0.0898438C8.41667 0.0898438 8.77083 0.235677 9.0625 0.527344C9.35417 0.81901 9.5 1.17318 9.5 1.58984V2.28984C10.8333 2.62318 11.9167 3.32734 12.75 4.40234C13.5833 5.47734 14 6.70651 14 8.08984V15.0898H15C15.2833 15.0898 15.5208 15.1857 15.7125 15.3773C15.9042 15.569 16 15.8065 16 16.0898C16 16.3732 15.9042 16.6107 15.7125 16.8023C15.5208 16.994 15.2833 17.0898 15 17.0898H1ZM8 20.0898C7.45 20.0898 6.97917 19.894 6.5875 19.5023C6.19583 19.1107 6 18.6398 6 18.0898H10C10 18.6398 9.80417 19.1107 9.4125 19.5023C9.02083 19.894 8.55 20.0898 8 20.0898ZM4 15.0898H12V8.08984C12 6.98984 11.6083 6.04818 10.825 5.26484C10.0417 4.48151 9.1 4.08984 8 4.08984C6.9 4.08984 5.95833 4.48151 5.175 5.26484C4.39167 6.04818 4 6.98984 4 8.08984V15.0898Z" fill="black" />
              </svg>
              {blinkNotification && <span className="noticount"></span>}
            </span>

          }
        >
          {
            isLoading ?
              [1, 2].map(m => {
                return (
                  <ShimmerNotification
                    key={`notify-${m}-shimmer`}
                  />
                )
              })
              :
              <>
                <div className="rows my_learningpath_tab">
                  <Tabs
                    onSelect={(k) => {
                      console.log('Tabs', isLoading)
                      if (k !== activeTab && !isLoading) {
                        setIsLoading(true)
                        setNotification([]);
                        setActiveTab(k)
                        if (k === "all") {
                          onClickOfAllTab();
                        } else {
                          onClickOfUnreadTab();
                        }
                      }
                    }}
                    activeKey={activeTab}
                    defaultActiveKey="unread"
                    className="containe-notify">
                    <Tab eventKey="unread" title="Unread" >
                      {notification.length === 0 && shimmerLoading ? [1, 2].map(m => {
                        return (
                          <ShimmerNotification
                            key={`notify-${m}-shimmer`}
                          />
                        )
                      }) : notification.length > 0 ? <div className="scroll-nofify" ref={unreadcontainerRef} onScroll={() => handleScrollUnread()}>
                        {notification.map((item, i) => {
                          return (
                            <>
                              <NavDropdown.Item
                                key={`notify-${i + 1}`}
                                className="get_CertifiedContainer dropdownItem_notiFcation"
                              >
                                <div className="getCertified">
                                  <a href="#">
                                    {" "}
                                  </a>
                                </div>
                                <div
                                  className="getCertified_content"
                                  onClick={() => item.status === 'read' ? goToNotification(item.redirection_key,
                                    item.id,
                                    item?.redirection_value, item) : markAsRead(item.id)}
                                >
                                  <h6
                                    className={`${item.status === "read" ? "hide-bold" : ""
                                      }`}
                                  >
                                    {item?.notification_content}
                                  </h6>
                                  <p className="text-right">

                                    {timezone ? moment.utc(
                                      item.created_at,
                                      "YYYY-MM-DD hh:mm:ss"
                                    ).tz(timezoneArea(timezone)).fromNow()
                                      :
                                      moment.utc(
                                        item.created_at,
                                        "YYYY-MM-DD hh:mm:ss"
                                      ).tz(timezoneArea('-0500')).fromNow()
                                    }
                                  </p>
                                </div>
                              </NavDropdown.Item>
                            </>
                          );
                        })}
                        {loader ? [1, 2].map(m => {
                          return (
                            <ShimmerNotification
                              key={`notify-${m}-shimmer`}
                            />
                          )
                        }) : <></>}
                      </div> : <p className="no-notifation">{!clickedShowUnread && notification?.length === 0 ? "Yet to receive notifications." : "No unread messages."}</p>}
                    </Tab>
                    <Tab eventKey="all" title="All"  >
                      {notification.length === 0 && shimmerLoading ? [1, 2].map(m => {
                        return (
                          <ShimmerNotification
                            key={`notify-${m}-shimmer`}
                          />
                        )
                      }) :
                        notification.length > 0 ? <>
                          <div className="scroll-nofify" ref={containerRef} onScroll={() => handleScroll()}>
                            {notification.map((item, i) => {
                              return (
                                <>
                                  <NavDropdown.Item
                                    id={`notify-${i + 1}`}
                                    key={`notify-${i + 1}`}
                                    className="get_CertifiedContainer dropdownItem_notiFcation"
                                  >
                                    <div className="getCertified">
                                      <a href="#">
                                        {" "}
                                      </a>
                                    </div>
                                    <div
                                      className="getCertified_content"
                                      onClick={() => item.status === 'read' ? goToNotification(item.redirection_key,
                                        item.id,
                                        item?.redirection_value, item) : markAsRead(item.id)}
                                    >
                                      <h6
                                        className={`${item.status === "read" ? "hide-bold" : ""
                                          }`}
                                      >
                                        {item?.notification_content}
                                      </h6>
                                      <p className="text-right">

                                        {timezone ? moment.utc(
                                          item.created_at,
                                          "YYYY-MM-DD hh:mm:ss"
                                        ).tz(timezoneArea(timezone)).fromNow()
                                          :
                                          moment.utc(
                                            item.created_at,
                                            "YYYY-MM-DD hh:mm:ss"
                                          ).tz(timezoneArea('-0500')).fromNow()
                                        }
                                      </p>
                                    </div>
                                  </NavDropdown.Item>
                                </>
                              );
                            })}
                            {loader ? [1, 2].map(m => {
                              return (
                                <ShimmerNotification
                                  key={`notify-${m}-shimmer`}
                                />
                              )
                            }) : <></>}
                          </div>
                        </> :
                          <p className="no-notifation">{!clickedShowUnread && notification?.length === 0 ? "Yet to receive notifications." : "No unread messages."}</p>}
                    </Tab>

                  </Tabs>
                </div>
                {!clickedShowUnread && notification?.length === 0 ? "" : <div className="getCertified buutndf">

                  {false && <button
                    type="button"
                    className="btn btn-primary btn-block setup-button markAll_btn"
                    onClick={() => {
                      setImgLoader(true);
                      setClickedShowUnread(true)
                      showUnRead
                        ? getNotificationList()
                        : getNotificationAllUnread();
                      setShowUnRead(!showUnRead);
                    }}
                  >
                    {imgLoader ? (
                      <div className="d-flex justify-content-center w-100">
                        <Spinner animation="border" />
                      </div>
                    ) : showUnRead ? (
                      "Show all"
                    ) : (
                      "Show unread only"
                    )}

                  </button>}
                  <button
                    className="getNotFieedbutton btn-primary"
                    onClick={() => {
                      markAllAsRead()
                    }}
                  >
                    Mark all as read
                  </button>
                  <button
                    className="getNotFieedbutton btn-primary"
                    onClick={() => {
                      document.getElementById("myCheck").click();
                      setCounter(0);
                      setNotification([]);
                    }}
                  >
                    Close
                  </button>

                </div>}
              </>
          }
        </NavDropdown>
      </li>
    </>
  );

};

export default Notification;


